<h2 mat-dialog-title>
    <mat-icon class="title-icon">publish</mat-icon>
    Publish as template
</h2>

<mat-dialog-content class="publish-content">
    <ng-container *ngIf="ownerCheckPending">
        <div class="publish-loading">
            <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
            <span>Verifying owner status…</span>
        </div>
    </ng-container>

    <ng-container *ngIf="!ownerCheckPending && !isOwner">
        <div class="publish-error">
            <mat-icon>lock</mat-icon>
            <span>{{ ownerMessage }}</span>
        </div>
    </ng-container>

    <form *ngIf="!ownerCheckPending && isOwner" class="publish-form" (ngSubmit)="submit()" #form="ngForm">
        <p class="hint">
            Snapshots the selected parts of this organization into a reusable template.
            <strong>Staff assignments are never included</strong> — templates carry the shape of an org, not the people.
        </p>

        <mat-form-field appearance="outline">
            <mat-label>Template name</mat-label>
            <input
                matInput
                name="name"
                [(ngModel)]="name"
                required
                maxlength="120"
                autocomplete="off"
            />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Description (optional)</mat-label>
            <textarea
                matInput
                name="description"
                [(ngModel)]="description"
                maxlength="500"
                rows="3"
            ></textarea>
        </mat-form-field>

        <fieldset class="scope-field">
            <legend>What should the template include?</legend>
            <div class="scope-grid">
                <mat-checkbox [checked]="true" [disabled]="true" matTooltip="Structure (parts) is always included.">
                    <span class="scope-title">Organization structure</span>
                    <span class="scope-sub">Parts tree (always included).</span>
                </mat-checkbox>
                <mat-checkbox name="includeFeatures" [(ngModel)]="includeFeatures">
                    <span class="scope-title">Features</span>
                    <span class="scope-sub">Which feature flags are enabled.</span>
                </mat-checkbox>
                <mat-checkbox name="includeSettings" [(ngModel)]="includeSettings">
                    <span class="scope-title">Settings</span>
                    <span class="scope-sub">Date cycles, working hours, approval rules.</span>
                </mat-checkbox>
                <mat-checkbox name="includeHats" [(ngModel)]="includeHats">
                    <span class="scope-title">Hats</span>
                    <span class="scope-sub">Job definitions linked to posts. User assignments stripped.</span>
                </mat-checkbox>
                <mat-checkbox name="includeSGs" [(ngModel)]="includeSGs">
                    <span class="scope-title">Security groups</span>
                    <span class="scope-sub">Permission bundles (feature × permission grids).</span>
                </mat-checkbox>
                <mat-checkbox name="includePolicies" [(ngModel)]="includePolicies">
                    <span class="scope-title">Policies</span>
                    <span class="scope-sub">Static policy bodies + per-hat bindings.</span>
                </mat-checkbox>
            </div>

            <div *ngFor="let warning of dependencyWarnings" class="scope-warning">
                <mat-icon>warning_amber</mat-icon>
                <span>{{ warning.message }}</span>
            </div>
        </fieldset>

        <fieldset class="visibility-field">
            <legend>Who can use this template?</legend>
            <mat-radio-group name="visibility" [(ngModel)]="visibility" class="visibility-radio-group">
                <mat-radio-button value="org-private">
                    <span class="radio-title">Only this organization</span>
                    <span class="radio-sub">Members of this org can use the template via the wizard's Curated picker.</span>
                </mat-radio-button>
                <mat-radio-button value="shared">
                    <span class="radio-title">Share with specific organizations</span>
                    <span class="radio-sub">Members of the listed orgs can also use it.</span>
                </mat-radio-button>
            </mat-radio-group>
        </fieldset>

        <mat-form-field *ngIf="visibility === 'shared'" appearance="outline">
            <mat-label>Share with org keys</mat-label>
            <textarea
                matInput
                name="sharedWith"
                [(ngModel)]="sharedWithRaw"
                rows="3"
                placeholder="org-key-1, org-key-2, …"
            ></textarea>
            <mat-hint>Comma- or newline-separated organization keys.</mat-hint>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="submitting">Cancel</button>
    <button
        *ngIf="!ownerCheckPending && isOwner"
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!canSubmit"
        (click)="submit()"
    >
        <mat-icon>publish</mat-icon>
        {{ submitting ? 'Publishing…' : 'Publish' }}
    </button>
</mat-dialog-actions>
